import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/security/auth.service';

export type ProfileOption =
    | 'profile'
    | 'profile-modification'
    | 'change-password'
    | 'bank'
    | 'bank-modification'
    | 'receipts'
    | 'insured'
    | 'notifications'
    | 'consent'
    | 'help';

@Component({
    selector: 'app-profile-sidebar',
    templateUrl: './profile-sidebar.component.html',
    styleUrls: ['./profile-sidebar.component.scss']
})
export class ProfileSidebarComponent implements OnInit {

    @Input() userFullName: string = '';
    @Input() userEmail: string = '';
    @Input() active: ProfileOption = 'profile';

    // "Mis asegurados" solo aplica a pólizas de Asistencia Jurídica Familiar (DJ29). Se
    // calcula en el componente padre (profile-page), que ya necesita este mismo dato para
    // otros fines, y se recibe aquí como Input en vez de volver a llamar al servicio.
    @Input() hasLegalAssistanceProduct: Boolean = false;

    @Output() optionChange = new EventEmitter<ProfileOption>();

    // El consentimiento es cosa del tomador: es quien contrata la póliza. Lo calcula
    // profile-page, que ya necesita el dato, y llega como Input.
    @Input() isTaker: Boolean = false;

    showDirectAreas: Boolean = true;

    constructor(private router: Router, private authService: AuthService) {}

    ngOnInit() {
        if ((this.authService.isLogged())) {
            this.authService.getSelectedEntity() === 'ONLYGAL' ? this.showDirectAreas = true : this.showDirectAreas = false;
        }
    }

    select(option: ProfileOption): void {
        this.active = option;
        this.optionChange.emit(option);
    }

    logout(): void {
        this.router.navigate(['/logout']);
    }
}
